import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPermissionsForRoute } from '../utils/adminNavConfig';
import { canAccessAny, getUserPermissionsFromAuth } from '../utils/userPermissions';

/**
 * Guards a single page by permission list or route path.
 */
const PermissionGate = ({ permissions, path, children }) => {
  const auth = useSelector((state) => state.auth);
  const userPermissions = getUserPermissionsFromAuth(auth);
  const required =
    permissions?.length > 0 ? permissions : getPermissionsForRoute(path);

  if (!required?.length) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (canAccessAny(userPermissions, required)) {
    return children;
  }

  return <Navigate to="/unauthorized" replace />;
};

PermissionGate.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
  path: PropTypes.string,
  children: PropTypes.node,
};

export default PermissionGate;
